import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TablePagination from "@saleor/components/TablePagination";
import { maybe, renderCollection } from "@saleor/misc";
import { ListProps } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";

import { VoucherReport_voucherReport_edges_node } from "../../types/VoucherReport";

const useStyles = makeStyles(
  theme => ({
    colRow: {
      "& th": {
        fontWeight: 600 as 600,
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1)
      }
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "InventoryList" }
);

interface VoucherListProp extends ListProps {
  vouchers: VoucherReport_voucherReport_edges_node[];
}

const VoucherList: React.FC<VoucherListProp> = ({
  vouchers,
  onNextPage,
  onPreviousPage,
  onUpdateListSettings,
  onRowClick,
  pageInfo,
  settings,
  disabled
}) => {
  const colNum = 5;
  const classes = useStyles({});

  return (
    <>
      <ResponsiveTable className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCellHeader>
              <FormattedMessage defaultMessage="Voucher Code " />
            </TableCellHeader>
            <TableCellHeader>
              <FormattedMessage defaultMessage="Mall" />
            </TableCellHeader>
            <TableCellHeader>
              <FormattedMessage defaultMessage="Amount " />
            </TableCellHeader>
            <TableCellHeader>
              <FormattedMessage defaultMessage="Discount " />
            </TableCellHeader>
            <TableCellHeader>
              <FormattedMessage defaultMessage="Status " />
            </TableCellHeader>
          </TableRow>
        </TableHead>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={colNum}
              settings={settings}
              hasNextPage={
                pageInfo && !disabled ? pageInfo.hasNextPage : undefined
              }
              onNextPage={onNextPage}
              onUpdateListSettings={onUpdateListSettings}
              hasPreviousPage={
                pageInfo && !disabled ? pageInfo.hasPreviousPage : undefined
              }
              onPreviousPage={onPreviousPage}
            />
          </TableRow>
        </TableFooter>
        <TableBody>
          {vouchers &&
            renderCollection(
              vouchers,
              (voucher, index) => (
                <TableRow
                  hover={!!voucher}
                  key={voucher ? index : "skeleton"}
                  className={!!voucher ? classes.tableRow : undefined}
                  onClick={
                    voucher
                      ? onRowClick(btoa(`Voucher:${atob(voucher.voucher_id)}`))
                      : undefined
                  }
                >
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => voucher.voucher_code,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => voucher.mall_name,
                      <Skeleton />
                    )}
                  </TableCell>

                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => voucher.total_net_amount,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => voucher.discount_value,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    {maybe<React.ReactNode>(() => voucher.status, <Skeleton />)}
                  </TableCell>
                </TableRow>
              ),
              () => (
                <TableRow>
                  <TableCell colSpan={colNum}>
                    <FormattedMessage defaultMessage="No vouchers found" />
                  </TableCell>
                </TableRow>
              )
            )}
        </TableBody>
      </ResponsiveTable>
    </>
  );
};

export default VoucherList;
